import React, { useEffect, useState } from "react";
import { Box, CheckBox } from "grommet";
import { HeaderNav } from ".";
import { useSelector } from "react-redux";

export const HeaderNavItems = () => {
	const userSession = useSelector((state) => {
		return state.session;
	});
	const [showProfilePicture, setShowProfilePicture] = useState(true);

	useEffect(() => {
		if (userSession.authenticated && userSession.user.image) setShowProfilePicture(true);
	}, [userSession]);

	return (
		<Box align='start' gap='medium'>
			<HeaderNav />
			<CheckBox label='Profile Picture' toggle checked={showProfilePicture} />
		</Box>
	);
};
